import styled from 'styled-components';
import FlexMainWrapper from '../wrappers/FlexMainWrapper';
import { SText } from '../text/ContentText';
import { Checkbox } from '../checkboxs/CheckboxInput';
const TableFilter = ({ wrapperStyle, arrFilterSt, topFilterSt, originfilter = true, topFilterLists = [], orderLists = [], filterLists = [], param, setParam, dispatch, research }) => {
    const onHandleChangeFilter = (list, item) => (e) => {
        onChangeCheck(e.target.checked, list, item);
    };

    const onChangeCheck = (checked, list, item) => {
        const tmp = param;
        if (checked) {
            tmp[list.key] = [...(tmp[list.key] ?? []), String(item.key)];
        } else {
            if (tmp[list.key].length === 0) delete tmp[list.key];
            else tmp[list.key] = tmp[list.key].filter((e) => String(e) !== String(item.key));
        }
        if (dispatch) dispatch(tmp);
        setParam({ ...tmp });
        research?.current?.refresh();
    };

    return (
        <FilterTableScrollWrapper style={{ ...wrapperStyle }}>
            <FilterTableWrapper>
                <tbody>
                    {topFilterLists.map((item, index) => {
                        return (
                            <tr className="top-filter" key={index}>
                                <td style={{ ...topFilterSt, backgroundColor: '#f2f4f6', width: '100px' }}>
                                    <SText text={item.filterText} style={{ width: '100px', fontWeight: 500 }} />
                                </td>
                                <td style={{ ...topFilterSt, width: `${item.width}px` }}>
                                    <OrderByFilter
                                        checkedType={item.checkedType}
                                        lists={item.orderLists}
                                        onChange={item.onChange}
                                        orderbyType={item.orderbyType}
                                    />
                                </td>
                            </tr>
                        );
                    })}
                    {originfilter &&
                        filterLists.map((item, index) => {
                            if (!item?.filter?.length) return null;
                            return (
                                <tr key={index}>
                                    <td style={{ backgroundColor: '#f2f4f6', width: '100px' }}>
                                        <SText text={item.value} style={{ width: '100px', fontWeight: 500 }} />
                                    </td>
                                    <td>
                                        <FlexMainWrapper style={{ alignItems: 'center', ...arrFilterSt, flexWrap: 'nowrap', width: 'max-content', whiteSpace: 'nowrap' }}>
                                            {item?.filter?.map((filterItem, index) => {
                                                const check = param[item.key]?.find((data) => Number(data) === Number(filterItem.key));
                                                return (
                                                    <Checkbox
                                                        checked={check !== undefined}
                                                        wrapperWidth={false}
                                                        containerStyle={{ flex: '0 0 auto', whiteSpace: 'nowrap' }}
                                                        width={filterItem.width}
                                                        key={index}
                                                        reverse={true}
                                                        text={filterItem.value}
                                                        checkedTitleStyle={{ whiteSpace: 'nowrap' }}
                                                        onChange={onHandleChangeFilter(item, filterItem)}
                                                    />
                                                );
                                            })}
                                        </FlexMainWrapper>
                                    </td>
                                </tr>
                            );
                        })}
                </tbody>
            </FilterTableWrapper>
        </FilterTableScrollWrapper>
    );
};

export default TableFilter;

const OrderByFilter = ({ checkedType = false, lists = [], orderbyType, onChange = () => {} }) => {
    return (
        <OrderByFlexWrapper>
            {lists?.map((item, index) => {
                return (
                    <Checkbox
                        boxBlur={item.boxBlur}
                        mobileOn
                        key={index}
                        wrapperWidth={false}
                        containerStyle={{ flex: '0 0 auto', whiteSpace: 'nowrap' }}
                        reverse={true}
                        text={item?.name}
                        width={item?.width}
                        checkedTitleStyle={{ whiteSpace: 'nowrap' }}
                        onChange={(e) => onChange(e, item?.type)}
                        checked={
                            checkedType && Array.isArray(orderbyType)
                                ? orderbyType.includes(item?.type ?? index + 1)
                                : item.type != undefined && item.type != null
                                  ? item?.type === orderbyType
                                  : index + 1 === orderbyType
                        }
                    />
                );
            })}
        </OrderByFlexWrapper>
    );
};

const FilterTableScrollWrapper = styled.div`
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
`;

const FilterTableWrapper = styled.table`
    margin-bottom: 20px;
    border-collapse: collapse;
    width: max-content;
    min-width: 100%;
    tbody > tr > td {
        text-align: start;
        padding: 5px;
        border-top: 1px solid #c7c7c7;
        border-bottom: 1px solid #c7c7c7;
    }
`;

const OrderByFlexWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: start;
    width: max-content;
    flex-wrap: nowrap;
    white-space: nowrap;
    gap: 7px;
`;
